import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ICheckboxQuestionMeta, IRadioQuestionMeta } from '../../../intake_survey/builders/ap_intake_survey_builder';
import { IInTakeSurveyQuestionChoice } from '../../../intake_survey/builders/ap_intake_survey_question_choice_builder';
import { PollServant } from '../../../intake_survey/servants/poll_servant';
import { APPreviewPlanServant } from './servants/ap_preview_plan_servant';
class PreviewTermsPlanHeader {
  private estimatedGraduationTime: string;
  private timeCommitmentQuestion: IRadioQuestionMeta;
  private termPreferenceQuestion: ICheckboxQuestionMeta;
  private previewPlanAction: () => void;
  private previousScreen: string;
  private alertTemplateIssue: boolean;
  private alertSelectMoreTerms: boolean;
  private previewPlan: () => void;
  private terms: any[];
  private previouslySelectedChoices:
    | [IInTakeSurveyQuestionChoice['nk'], Array<IInTakeSurveyQuestionChoice['nk']>]
    | any = [];

  constructor(
    private loadTermPreviewPlanCommand: ICommand,
    private clearTermPreviewPlanCommand: ICommand,
    private ngTermPlanPreviewQuery: IQuery,
    private log: any
  ) {
    this.estimatedGraduationTime = '';
  }

  clearEstimatedGraduationTime() {
    this.estimatedGraduationTime = '';
  }

  checkSelectionGetPlan() {
    this.alertSelectMoreTerms = this.showCheckboxNoneSelected();
    if (this.alertSelectMoreTerms) {
      return;
    }
    this.getPreviewPlan();
  }

  previewPlanClicked() {
    this.checkSelectionGetPlan();
  }

  showCheckboxNoneSelected() {
    return this.termPreferenceQuestion && !PollServant.hasEveryQuestionAnswered([this.termPreferenceQuestion]);
  }

  getSelectedChoices() {
    return [this.timeCommitmentQuestion._answer.nk, _4.map(this.termPreferenceQuestion._answer, 'nk')];
  }

  getPreviewPlan() {
    const [termCommitment, termPreference] = this.getSelectedChoices();
    this.clearTermPreviewPlanCommand().then(() => {
      this.log.disable();
      this.loadTermPreviewPlanCommand(termCommitment, termPreference)
        .then(() => {
          this.previouslySelectedChoices = this.getSelectedChoices();
          this.estimatedGraduationTime = APPreviewPlanServant.getEstimatedGraduationDateFromTerm(
            this.ngTermPlanPreviewQuery.result.terms
          );
          if (this.estimatedGraduationTime) {
            this.alertTemplateIssue = false;
          }
          this.log.enable();
        })
        .catch((e: any) => {
          this.alertTemplateIssue = true;
          this.log.enable();
        });
    });
  }
}

angular.module('capability-ng-academic-planner').component('previewTermsPlanHeader', {
  templateUrl:
    'capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_terms_plan_header/preview_terms_plan_header.html',
  bindings: {
    timeCommitmentQuestion: '<',
    termPreferenceQuestion: '<',
    alertTemplateIssue: '=',
    alertSelectMoreTerms: '=',
    previewPlan: '&',
    terms: '=',
    previousScreen: '<'
  },
  controller: PreviewTermsPlanHeader
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_terms_plan_header/preview_terms_plan_header.ts